import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";

export function EmployeeEvolutionChart({ months = [], values = [], team = [], name, testid }) {
  if (months.length < 2) return null;
  const data = months.map((m, i) => ({ label: `${m.label}${m.is_base ? " · base" : ""}`, emp: values[i] ?? null, team: team[i] ?? null }));
  const last = values[values.length - 1];
  const first = values.find((v) => v != null);
  const color = last != null && first != null && last < first ? "#e11d48" : "#059669";
  return (
    <div className="bg-white border border-slate-200 rounded-lg p-3 mb-3" data-testid={testid}>
      <div className="flex items-center gap-4 text-[10px] uppercase tracking-wider font-bold text-slate-500 mb-1">
        <span>Evolución % genérico</span>
        <span className="inline-flex items-center gap-1 normal-case tracking-normal" style={{ color }}><span className="h-0.5 w-4 inline-block" style={{ background: color }} /> {name}</span>
        <span className="inline-flex items-center gap-1 normal-case tracking-normal text-slate-400"><span className="h-0.5 w-4 inline-block border-t-2 border-dashed border-slate-400" /> Media farmacia</span>
      </div>
      <div className="h-36">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data} margin={{ top: 8, right: 16, bottom: 0, left: -18 }}>
            <CartesianGrid stroke="#f1f5f9" vertical={false} />
            <XAxis dataKey="label" tick={{ fontSize: 10, fill: "#64748b" }} tickLine={false} axisLine={false} />
            <YAxis domain={[0, 100]} tick={{ fontSize: 10, fill: "#94a3b8" }} tickLine={false} axisLine={false} unit="%" />
            <Tooltip formatter={(v, k) => [v == null ? "—" : `${String(v).replace(".", ",")}%`, k === "emp" ? name : "Media farmacia"]} />
            <Line type="monotone" dataKey="team" stroke="#94a3b8" strokeDasharray="4 3" strokeWidth={1.5} dot={false} connectNulls />
            <Line type="monotone" dataKey="emp" stroke={color} strokeWidth={2.5} dot={{ r: 3.5, fill: color }} connectNulls isAnimationActive />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
